import { render, staticRenderFns } from "./trace-item.vue?vue&type=template&id=cdcab04c&scoped=true&"
import script from "./trace-item.vue?vue&type=script&lang=js&"
export * from "./trace-item.vue?vue&type=script&lang=js&"
import style0 from "./trace-item.vue?vue&type=style&index=0&id=cdcab04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcab04c",
  null
  
)

export default component.exports